import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Container,
  TextField,
  Grid,
  Chip,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ContentCopyIconBtn, MainTitle } from "./styles";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import { styled } from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import AddIcon from "@mui/icons-material/Add";
import client, {
  UI_HOST,
  userSession,
} from "../../services/auth/ApiService/client";
import { IAnketa } from "../ChangePage/ChangePage";
import { UserDataSumm } from "../BuhPage/BuhPage";
import { formatNumber } from "../../utils/numbers";
import {
  maskPhone,
  normalizeEmailInput,
  PHONE_MASK_PLACEHOLDER,
} from "../../utils/inputMasks";

const AnketaContainer = styled(Box)`
  display: flex;
  flex-wrap: wrap;
`;

const ANKETA_STATUS_LABELS: Record<string, string> = {
  DRAFT: "Черновик",
  PENDING_REVIEW: "На модерации",
  PUBLISHED: "Опубликована",
  REJECTED: "Отклонена",
  ARCHIVED: "В архиве",
  active: "Опубликована",
};

const ANKETA_STATUS_COLORS: Record<
  string,
  "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning"
> = {
  DRAFT: "default",
  PENDING_REVIEW: "warning",
  PUBLISHED: "success",
  REJECTED: "error",
  ARCHIVED: "default",
  active: "success",
};

const getAnketaStatusLabel = (status?: string) =>
  ANKETA_STATUS_LABELS[status ?? ""] ?? "Статус не указан";

const getAnketaStatusColor = (status?: string) =>
  ANKETA_STATUS_COLORS[status ?? ""] ?? "default";

const canOpenPublicAnketa = (status?: string) =>
  status === "PUBLISHED" || status === "active";

const canPreviewAnketa = (status?: string) => status === "PENDING_REVIEW";

export interface IReferalState {
  count: number;
  percent: number;
}
export interface IProfile {
  id?: string;
  email?: string;
  phone?: string;
  city?: string;
  name?: string;
  persentIsFixed?: number;
  referalPercent?: boolean;
  referalId?: string;
  nextCount?: number;
  referalState?: IReferalState[];
  summ?: number;
  photo?: { buffer?: File; src: string };
}

export const getMonthByDate = (month: number) => {
  const months = [
    "Января",
    "Февраля",
    "Мерта",
    "Апреля",
    "Мая",
    "Июня",
    "Июля",
    "Августа",
    "Сентября",
    "Октября",
    "Ноября",
    "Декабря",
  ];
  return months[month];
};

const ProfilePage = () => {
  const [ankets, setAnkets] = useState<IAnketa[]>([]);
  const [anketsRef, setAnketsRef] = useState<IAnketa[]>([]);
  const [profile, setProfile] = useState<IProfile>({
    name: "",
    email: "",
    phone: "",
  });
  const [userDataSumm, setUserDataSumm] = React.useState<UserDataSumm>({
    cost: 0,
    income: 0,
  });
  const navigate = useNavigate();

  useEffect(() => {
    const loadData = () => {
      client.get("/ankets").then((response) => {
        const { data } = response;
        setAnkets(data);
      });
      client
        .get(`/services/user`)
        .then((response) => {
          const data = response.data as UserDataSumm;
          console.log(data);
          setUserDataSumm(data);
        })
        .catch((error) => {
          console.log("error");
          console.log(error);
        });
      client.get("/my-profile").then((response) => {
        const { data } = response;
        setProfile({
          ...data,
          email: data?.email ? normalizeEmailInput(data.email) : "",
          phone: data?.phone ? maskPhone(data.phone) : "",
        });
        console.log(data);
        if (data?.referalId) {
          client.get(`/ankets?referal=${data?.referalId}`).then((response) => {
            const { data: dataRef } = response;
            console.log(dataRef);
            setAnketsRef(dataRef);
          });
        }
      });
    };
    loadData();
  }, []);
  const onBoxSubmit = (event: React.FormEvent<HTMLDivElement>) => {
    event.preventDefault();
    const formData = anketaToFormData(profile);
    console.log(formData);
    client.post("/my-profile", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const handleDelete = (id: string | undefined) => {
    console.log(11);
    if (id) {
      client.delete(`/anketas/${id}`).then((response) => {
        console.log(response);
        client.get("/ankets").then((response) => {
          const { data } = response;
          setAnkets(data);
        });
      });
    }
  };

  const anketaToFormData = (obj: any, form?: any, namespace?: any) => {
    const formData = form || new FormData();
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        const formKey = namespace ? `${namespace}[${property}]` : property;
        if (obj[property] instanceof File) {
          formData.append(formKey, obj[property] as Blob);
        } else if (Array.isArray(obj[property])) {
          obj[property].forEach((element: any, index: any) => {
            const tempFormKey = `${formKey}[${index}]`;
            if (typeof element === "object" && !(element instanceof File)) {
              anketaToFormData(element, formData, tempFormKey);
            } else {
              formData.append(tempFormKey, element);
            }
          });
        } else if (
          typeof obj[property] === "object" &&
          !(obj[property] instanceof File)
        ) {
          anketaToFormData(obj[property], formData, formKey);
        } else {
          formData.append(formKey, obj[property]);
        }
      }
    }

    return formData;
  };
  return (
    <>
      <Container
        style={{ marginTop: "120px", paddingLeft: "0px", paddingRight: "0px" }}
      >
        <MainTitle variant="h4" sx={{ marginBottom: "40px" }}>
          Основные данные пользователя
        </MainTitle>
        {profile?.referalPercent && (
          <Card sx={{ minWidth: 275 }}>
            <CardContent>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                Вы являетесь партнером
              </Typography>
              <Typography variant="h5" component="div">
                Ваши текущие доходы: <b>{formatNumber(userDataSumm.income)}</b>{" "}
                руб.
              </Typography>
              <Typography variant="h5" component="div">
                Ваши текущие расходы: <b>{formatNumber(userDataSumm.cost)}</b>{" "}
                руб.
              </Typography>
              {/*<Typography sx={{ mb: 1.5 }} color="text.secondary">*/}
              {/*    Ваш текущий процент вознаграждения: <b>{profile?.referalPercent}%</b>*/}
              {/*</Typography>*/}
              {/*{profile?.nextCount && (<Typography variant="body2">*/}
              {/*    Заявок до следующего уровня вознаграждения: {profile?.nextCount}*/}
              {/*</Typography>)}*/}
              <Typography variant="body2">
                Ваша ссылка для заказа:{" "}
                <Link to={`${UI_HOST}/order?r=${profile?.referalId}`}>
                  https://предтечи.рф/order?r={profile?.referalId}
                </Link>{" "}
                <ContentCopyIconBtn
                  onClick={() =>
                    navigator.clipboard.writeText(
                      `${UI_HOST}/order?r=${profile?.referalId}`
                    )
                  }
                />
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                <Link to={`${UI_HOST}/summ`}>
                  Перейти на страницу доходов / расходов:
                </Link>
              </Typography>
            </CardContent>
          </Card>
        )}
        <Grid
          container
          spacing={5}
          style={{ marginTop: "10px", paddingLeft: "0px", paddingRight: "0px" }}
        >
          <Grid item xs={6}>
            <Box component="form" onSubmit={onBoxSubmit}>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  id="outlined-basic1"
                  label="ФИО"
                  variant="outlined"
                  defaultValue={profile?.name}
                  value={profile?.name}
                  onChange={(e: any) => {
                    setProfile({
                      ...profile,
                      name: e.target.value,
                    });
                  }}
                />
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  fullWidth
                  id="outlined-basic2"
                  label="Номер телефона"
                  variant="outlined"
                  placeholder={PHONE_MASK_PLACEHOLDER}
                  inputProps={{ inputMode: "numeric", maxLength: PHONE_MASK_PLACEHOLDER.length }}
                  defaultValue={profile?.phone}
                  value={profile?.phone ?? ""}
                  onChange={(e: any) => {
                    setProfile({
                      ...profile,
                      phone: maskPhone(e.target.value),
                    });
                  }}
                />
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  fullWidth
                  id="outlined-basic2"
                  label="Город"
                  variant="outlined"
                  defaultValue={profile?.city}
                  value={profile?.city ?? ""}
                  onChange={(e: any) => {
                    setProfile({
                      ...profile,
                      city: e.target.value,
                    });
                  }}
                />
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <TextField
                  id="outlined-basic3"
                  label="Email"
                  variant="outlined"
                  inputProps={{ inputMode: "email" }}
                  defaultValue={profile?.email}
                  value={profile?.email}
                  onChange={(e: any) => {
                    setProfile({
                      ...profile,
                      email: normalizeEmailInput(e.target.value),
                    });
                  }}
                />
              </FormControl>
              {/* <h4>Логотип</h4>
              <FormControl
                fullWidth
                sx={{ flexDirection: "row", flexWrap: "wrap" }}
              >
                <LoadButton variant="contained" component="label">
                  <svg
                    fill="#ffffff"
                    width="50"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M149.1 64.8L138.7 96H64C28.7 96 0 124.7 0 160V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H373.3L362.9 64.8C356.4 45.2 338.1 32 317.4 32H194.6c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z" />
                  </svg>
                  Загрузить изображения
                  <input
                    type="file"
                    multiple={true}
                    hidden
                    onChange={(e) => {
                      if (!e.target?.files?.length) return;
                      const src = URL.createObjectURL(e.target.files[0]);
                      setProfile({
                        ...profile,
                        photo: {
                          buffer: e.target.files[0],
                          src,
                        },
                      });
                    }}
                  />
                </LoadButton>
                {profile?.photo?.src && (
                  <img
                    src={profile?.photo?.src}
                    style={{
                      height: "160px",
                      margin: "5px",
                      objectFit: "cover",
                      display: "inline-block",
                    }}
                  />
                )}
              </FormControl> */}
              <Button sx={{ m: 1 }} variant="contained" type="submit">
                Сохранить
              </Button>
              <Box>
                <Button
                  sx={{ m: 1 }}
                  variant="contained"
                  color="error"
                  size="large"
                  onClick={(e) => {
                    e.preventDefault();
                    userSession.clearSession();
                    navigate("/");
                  }}
                >
                  Выйти из аккаунта
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Container
        style={{ marginTop: "40px", paddingLeft: "0px", paddingRight: "0px" }}
      >
        <MainTitle variant="h4" sx={{ marginBottom: "40px", m: 2 }}>
          Мои моменты памяти
        </MainTitle>
        <AnketaContainer>
          {ankets &&
            ankets?.map((anketa, key) => {
              const link = anketa.isSolder
                ? `/solder/${anketa.id}`
                : `/anketa/${anketa.id}`;
              const isPublished = canOpenPublicAnketa(anketa.status);
              const isPreviewAvailable = canPreviewAnketa(anketa.status);
              const viewLink = isPublished ? link : `${link}?preview=1`;
              return (
                <Card sx={{ width: 345, m: 2 }} key={key}>
                  <CardHeader
                    action={
                      <>
                        <IconButton
                          aria-label="view"
                          onClick={(e) => handleDelete(anketa.id)}
                        >
                          <DeleteIcon />
                        </IconButton>
                        {isPublished || isPreviewAvailable ? (
                          <Link to={viewLink}>
                            <IconButton aria-label="view">
                              <RemoveRedEyeIcon />
                            </IconButton>
                          </Link>
                        ) : (
                          <IconButton aria-label="view" disabled>
                            <RemoveRedEyeIcon />
                          </IconButton>
                        )}
                        <Link to={`/change/${anketa.id}`}>
                          <IconButton aria-label="settings">
                            <EditIcon />
                          </IconButton>
                        </Link>
                      </>
                    }
                    title={anketa.name}
                    subheader={anketa.dateBorn + " - " + anketa.dateEnd}
                    sx={{ height: "115px", alignItems: "flex-start" }}
                  />
                  <CardMedia
                    component="img"
                    height="194"
                    image={anketa?.photo?.src}
                    alt={anketa?.name}
                  />
                  <CardContent sx={{ pb: 0 }}>
                    <Chip
                      label={getAnketaStatusLabel(anketa.status)}
                      color={getAnketaStatusColor(anketa.status)}
                      size="small"
                    />
                    {!isPublished && isPreviewAvailable && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 1 }}
                      >
                        Предпросмотр доступен только вам. Публичная страница
                        станет доступна после публикации.
                      </Typography>
                    )}
                    {!isPublished && !isPreviewAvailable && (
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 1 }}
                      >
                        Публичная страница станет доступна после публикации.
                      </Typography>
                    )}
                  </CardContent>
                  {/* <CardActions disableSpacing>
                    {(anketa.isTrial || anketa?.orders[0]?.status === "NEW") &&
                    !anketa.isSolder ? (
                      <>
                        <Button
                          onClick={() =>
                            handlePay(anketa?.tariffId, anketa?.orderId)
                          }
                          variant="contained"
                          color="primary"
                          sx={{ m: 1 }}
                        >
                          Оплатить
                        </Button>
                        <span>
                          Анкета будет удалена <br /> {dateString}
                        </span>
                      </>
                    ) : (
                      <Typography variant="body2" sx={{ m: 1 }}>
                        Заказ оплачен
                      </Typography>
                    )}
                  </CardActions> */}
                </Card>
              );
            })}
        </AnketaContainer>

        {profile?.referalPercent ? (
          <Link to="/create/77dbaea6-8a97-446e-bf7c-ec6373ce9f7f">
            <Button sx={{ m: 2 }} size="large" variant="contained">
              <AddIcon />
              Создать Момент Памяти
            </Button>
          </Link>
        ) : (
          <Link to="/order">
            <Button sx={{ m: 2 }} size="large" variant="contained">
              <AddIcon />
              Создать Момент Памяти
            </Button>
          </Link>
        )}
        {/*{anketsRef?.length > 0 && (<>*/}
        {/*    <MainTitle variant="h4" sx={{marginBottom: '40px', m: 2}}>Моменты памяти клиентов</MainTitle>*/}
        {/*    <AnketaContainer>*/}
        {/*        {anketsRef && anketsRef?.map((anketa, key) => {*/}
        {/*            const link = anketa.isSolder ? `/solder/${anketa.id}` : `/anketa/${anketa.id}`;*/}
        {/*            const status = anketa.status === 'active' ? 'Активна' : 'Отключена';*/}
        {/*            const statusCheck = anketa.status === 'active';*/}
        {/*            const date = new Date(anketa.createdAt);*/}
        {/*            const dateString = `${date.getDate() + 1} ${getMonthByDate(date.getMonth())} ${date.getFullYear()} года`*/}
        {/*            return <Card sx={{ width: 345, m: 2 }} key={key}>*/}
        {/*                <CardHeader*/}
        {/*                    action={*/}
        {/*                        <>*/}
        {/*                            <Link to={link}>*/}
        {/*                                <IconButton aria-label="view">*/}
        {/*                                    <RemoveRedEyeIcon />*/}
        {/*                                </IconButton>*/}
        {/*                            </Link>*/}
        {/*                            <Link to={`/change/${anketa.id}`}>*/}
        {/*                                <IconButton aria-label="settings">*/}
        {/*                                    <EditIcon />*/}
        {/*                                </IconButton>*/}
        {/*                            </Link>*/}
        {/*                        </>*/}
        {/*                    }*/}
        {/*                    title={anketa.name}*/}
        {/*                    subheader={anketa.dateBorn + " - " + anketa.dateEnd}*/}
        {/*                    sx={{height: '115px', alignItems: 'flex-start'}}*/}
        {/*                />*/}
        {/*                <CardMedia*/}
        {/*                    component="img"*/}
        {/*                    height="194"*/}
        {/*                    image={anketa?.photo?.src}*/}
        {/*                    alt={anketa?.name}*/}
        {/*                />*/}
        {/*                <CardActions disableSpacing>*/}
        {/*                    {(anketa.isTrial || anketa?.orders[0]?.status === 'NEW') && !anketa.isSolder ? (*/}
        {/*                        <>*/}
        {/*                            <Button onClick={() => handlePay(anketa?.tariffId, anketa?.orderId)} variant="contained" color="primary" sx={{ m: 1 }}>Оплатить</Button>*/}
        {/*                            <span>Анкета будет удалена <br /> {dateString}</span>*/}
        {/*                        </>*/}
        {/*                    ) : (*/}
        {/*                        <FormControlLabel control={<Checkbox defaultChecked={statusCheck} />} label={status} sx={{ m: 1 }}/>*/}
        {/*                    )}*/}
        {/*                </CardActions>*/}
        {/*            </Card>*/}
        {/*        })}*/}
        {/*    </AnketaContainer>*/}
        {/*</>)}*/}
      </Container>
    </>
  );
};

export default ProfilePage;
